export function formatDate(iso: string | null): string {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function relativeAgo(iso: string | null): string {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const diff = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
    if (diff <= 0) return 'Today';
    if (diff < 30) return `${diff}d ago`;
    if (diff < 365) return `${Math.floor(diff / 30)}mo ago`;
    return `${Math.floor(diff / 365)}y ago`;
}

export function coverageColor(pct: number): string {
    if (pct >= 75) return '#3b6d11';
    if (pct >= 50) return '#854f0b';
    return '#a32d2d';
}

export function clientBadgeClass(client: string | null): string {
    switch (client) {
        case 'ENTERPRISE':
        case 'Enterprise':
            return 'badge bg-purple text-white';
        case 'PREMIUM':
        case 'Premium':
            return 'badge bg-info text-white';
        case 'STANDARD':
        case 'Standard':
            return 'badge bg-secondary text-white';
        default:
            return 'badge bg-light text-dark';
    }
}
